import {flow, types} from 'mobx-state-tree';
import {BuildsApiGateway} from '../../apiGateway/BuildsApiGateway';
import {Build} from './Builld';
import {BuildDto} from '../../apiGateway/Dtos/BuildDto';
import {MapDtoToBuildModel} from './BuildMap';

export const BuildsStore = types.model(
    'BuildsStore',
    {
        apiGateway: BuildsApiGateway,
        builds: types.array(Build),
        isLoading: false
    })
    .actions(self => ({

        getBuilds: flow(function* (projectId: string, buildType?: string) {

            self.isLoading = true;

            try {
                const buildDtos: BuildDto[] = buildType !== 'all' ? yield self.apiGateway.getBuildsOfType(projectId, buildType) : yield self.apiGateway.getBuilds(projectId);

                const builds = buildDtos.map((buildDto: BuildDto) => Build.create(MapDtoToBuildModel(buildDto)));

                self.builds.replace(builds);

                self.isLoading = false;

                return self.builds;

            } catch (e: any) {

                throw new Error(buildType !== 'all' ? `Could not find any ${buildType} builds` : 'No builds found');
            }
        })

    }));
